import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
  })
export class Reimbursementservice
{
 constructor(private http: HttpClient) { }
  getAllFormAttribute(selectedCategory){
    return this.http.get(environment.baseUrl+ "reimbursements/categories/"+selectedCategory+"/data",
      { headers: new HttpHeaders({"Authorization": 'Token token=' + localStorage.getItem('token'),
        "Content-Type": 'application/json'})})
  }

    getApproved(month,year)
  {

    return this.http.get(environment.baseUrl+"reimbursements/approved?start_month="+month+"&start_year="+year,
    { headers: new HttpHeaders({"Authorization": 'Token token=' + localStorage.getItem('token'),
     "Content-Type": 'application/json'})})
  }

  getUnapproved()
  {
    return this.http.get(environment.baseUrl+"reimbursements/unapproved",
    { headers: new HttpHeaders({"Authorization": 'Token token=' + localStorage.getItem('token'),
    "Content-Type": 'application/json'})})
  }

  getNextCycleApproved(month, year)
  {
    return this.http.get(
      environment.baseUrl+"reimbursements/next_cycle?start_month="+month+"&start_year="+year,
      {
        headers: new HttpHeaders({
          "Authorization": 'Token token=' + localStorage.getItem('token'),
          "Content-Type": 'application/json'
        })
      }
    )
  }

  getOnHold(month, year)
  {
    return this.http.get(
      environment.baseUrl+"reimbursements/on_hold?start_month="+month+"&start_year="+year,
      {
        headers: new HttpHeaders({
          "Authorization": 'Token token=' + localStorage.getItem('token'),
          "Content-Type": 'application/json'
        })
      }
    )
  }

  getRejected(month,year)
  {
    return this.http.get(environment.baseUrl+"reimbursements/rejected?start_month="+month+"&start_year="+year,
    { headers: new HttpHeaders({"Authorization": 'Token token=' + localStorage.getItem('token'),
      "Content-Type": 'application/json'})})
  }

  getSettledData(month,year)
  {
    return this.http.get(environment.baseUrl+"reimbursements/settled?start_month="+month+"&start_year="+year,
    { headers: new HttpHeaders({"Authorization": 'Token token=' + localStorage.getItem('token'),
      "Content-Type": 'application/json'})})
  }

  getDrafted(month,year) {
    return this.http.get(
      environment.baseUrl+"reimbursements/drafted?start_month="+month+"&start_year="+year,
      {
        headers: new HttpHeaders({
          "Authorization": 'Token token=' + localStorage.getItem('token'),
          "Content-Type": 'application/json'
        })
      }
    )
  }

  createReimbursement(formData){
     return this.http.post(environment.baseUrl+'reimbursements/',formData,{ headers: new HttpHeaders({"Authorization": 'Token token=' + localStorage.getItem('token'),
      "Content-Type": 'application/json'})})
  }

  draftReimbursement(formData){
    return this.http.post(
      environment.baseUrl+'reimbursements/draft',
      formData,
      {
        headers: new HttpHeaders({
          "Authorization": 'Token token=' + localStorage.getItem('token'),
          "Content-Type": 'application/json'
        })
      }
    )
  }

  updateReimbursement(id, formData){
    return this.http.put(
      environment.baseUrl+'reimbursements/'+id,
      formData,
      {
        headers: new HttpHeaders({
          "Authorization": 'Token token=' + localStorage.getItem('token'),
          "Content-Type": 'application/json'
        })
      }
    )
  }

  deletesingledata(reimbursement_id)
  {
    return this.http.delete(environment.baseUrl+ "reimbursements/"+reimbursement_id,
      { headers: new HttpHeaders({"Authorization": 'Token token=' + localStorage.getItem('token'),
        "Content-Type": 'application/json'})})
  }

  getTutorialVideo(params) {
    return this.http.post(
      environment.baseUrl + 'tutorial_videos/fetch_video_link',
      params,
      {
        headers: new HttpHeaders({
          "Authorization": 'Token token=' + localStorage.getItem('token'),
          "Content-Type": 'application/json'
        })
      }
    )
  }

  newReimbursement(params) {
    return this.http.get(
      environment.baseUrl + "reimbursements/new",
      {
        params: params,
        headers: new HttpHeaders({
          "Authorization": 'Token token=' + localStorage.getItem('token'),
          "Content-Type": 'application/json'
        })
      }
    )
  }

}
